import React from 'react';

import { useHistory } from 'react-router-dom';
import { useUserWithRole } from 'hooks/custom-auth';
import { getRoutePrefix } from 'utils/routes';
import Client from 'containers/app/client';
import { LayoutPage, LayoutHorizontal } from 'components/layouts';
import LoadingFullPage from 'components/loading-full-page';
import { Button } from 'antd';
import './style.css';

const TokenPurchase = () => {
  const history = useHistory();
  const [user, loading] = useUserWithRole(Client.auth);

  if (loading) return <LoadingFullPage />;

  const content = (
    <>
      <h1>That is great!</h1>
      <br />
      <p>
        Thank you for using MyShifts. You are now ready to start searching for
        trained and suitable workers to help you fill your vacant Shifts. You
        can do this by pressing the button below <strong>Search Workers</strong>
      </p>
    </>
  );

  const onDashboard = async () => {
    history.push(`${getRoutePrefix(user.claims.role)}/dashboard`);
  };

  const onSearch = async () => {
    history.push(`${getRoutePrefix(user.claims.role)}/worker-search`);
  };

  return (
    <LayoutPage className="token-purchase">
      <LayoutHorizontal className="token-purchase-container">
        <div className="content">
          {content}
          <Button type="primary" size="large" onClick={onDashboard}>
            Dashboard
          </Button>
          <Button type="primary" size="large" onClick={onSearch}>
            Search Workers
          </Button>
        </div>
      </LayoutHorizontal>
    </LayoutPage>
  );
};

export default TokenPurchase;
